import Grid from 'semantic-ui-react/dist/commonjs/collections/Grid'
export default Grid
